import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { AntepostParticipantsViewModel, FixtureParticipantPriceMap } from '@frontend/sports/racing/feature/models';

import { AntepostParticipantsComponent } from './antepost-participants.component';

@Component({
    selector: 'ms-antepost-common',
    templateUrl: 'antepost-common.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AntepostCommonComponent {
    @Input() vm: AntepostParticipantsViewModel<FixtureParticipantPriceMap> = AntepostParticipantsComponent.emptyViewModel;
    @Input() crmPromotedOptionIdsMap?: StringDictionary<number> = {};
}
